<template>
  <div class="qrlogin">
    <div class="qrcode">
      <!-- <div class="flash" v-show="flash">刷新页面更新二维码</div> -->
      <div class="flash" v-show="flash" @click="refresh">Click to update QR code</div>
      <Qrcode :size="size" cls="code" :value="qrcode"></Qrcode>
    </div>
    <div class="tips">Scan QR Code to login Vanish</div>
    <router-link to="/login">
      <div class="change">
        <img src='../assets/images/icon_password@2x.png' alt=""/>
      </div>
    </router-link>
  </div>
</template>

<script>
  import Vue from 'vue'
  import Qrcode from 'v-qrcode/src/index'
  import axios from 'axios'
  import qs from 'qs'
  import CryptoJS from 'crypto-js'
  import config from '../assets/js/config.js'
  import { ScanFlag } from '../new-login-2018/common/GeneralVariable.js'
  import { getDeviceInfo, isGrayEnv, jumpToMainWeb, setLoginInfo } from '../new-login-2018/common/utils.js'
  import Cipher from '../new-login-2018/common/Cipher.js'
  export default {
    data () {
      return {
        randomcode: '',
        aeskey: 0,
        ti: 0,
        qrcode: '',
        size: 240,
        flash: false
      }
    },
    mounted () {
      if (location.search.indexOf('?ua=') > -1 && location.search.indexOf('&version=') > -1) {
        let version = location.search.substr((location.search.indexOf('&version=') + 9))
        let pcVersion = 'pc/' + version
        localStorage.setItem('pcVersion', pcVersion)
      }
      this.longPolling()
    },
    methods: {
      refresh () {
        this.flash = false
        this.longPolling()
      },
      // 创建qrcode
      createqrcode () {
        this.randomcode = new Date().getTime().toString() + this.rando(3)
        this.aeskey = this.rando(16)
        let qrcode = {
          'id': this.randomcode,
          'aeskey': this.aeskey,
          'platform': 'web'
        }
        this.qrcode = JSON.stringify(qrcode)
        this.ti++
      },
      // 生成一个随机数
      rando (m) {
        let num = ''
        for (let i = 0; i < m; i++) {
          let val = parseInt(Math.random() * 10, 10)
          if (i === 0 && val === 0) {
            i--
            continue
          }
          num += val
        }
        return num
      },
      // 长连方法
      longPolling () {
        this.createqrcode()
        // 浏览器检测
        if (navigator.userAgent.indexOf('Chrome') === -1) {
          let messageTip = 'We highly recommend you to use Crait in Chrome for optimized user experience.'
          if (config.isVanish) {
            messageTip = 'We highly recommend you to use Vanish in Chrome for optimized user experience.'
          }
          Vue.prototype.$message({
            showClose: true,
//            message: '我们推荐您使用Chrome浏览器登录，以免出现兼容性问题！',
            message: messageTip,
            type: 'warning',
            duration: 0
          })
        } else {
          let ua = navigator.userAgent.toLowerCase()
          let s = ua.match(/chrome\/([\d.]+)/)
          if (parseInt(s[1]) < 62 && !(ua.indexOf('electron') > -1)) {
            Vue.prototype.$message({
              showClose: true,
//            message: '我们推荐您使用Chrome浏览器登录，以免出现兼容性问题！',
              message: 'The version of Chrome you are using is old. Update your browser to optimize user experience.',
              type: 'warning',
              duration: 0
            })
          }
        }
        axios({
          url: '/proxy-api/client/user/index/scan-login',
          params: {
            id: this.randomcode
          },
          method: 'post',
          timeout: 30000,
          responseType: 'json'
        }).then(async (result) => {
          let payload = result.data.payload
          let rpayload = payload.replaceAll('%2B', '+')
          let aeskeyhandle = CryptoJS.enc.Latin1.parse(this.aeskey)
          let decrypted = CryptoJS.AES.decrypt(rpayload, aeskeyhandle, {
            iv: aeskeyhandle,
            mode: CryptoJS.mode.ECB,
            padding: CryptoJS.pad.Pkcs7
          })
          let content = decrypted.toString(CryptoJS.enc.Utf8)
          content = JSON.parse(content)
          let email = content['email']
          let password = content['password']
          let privatekey = content['private_key']
          let publickey = content['public_key'] || ''
          let loginAccount = content['login_account']
          let type = content['type']
          // 存入ls
//          localStorage.setItem(email + '_privatekey', privatekey)
//          if (publickey) {
//            localStorage.setItem(email + '_publickey', publickey)
//          }

          // 登录
          let data = {}
          if (+type === 1) {
            if (privatekey) {
              localStorage.setItem(loginAccount + '_privatekey', privatekey)
            }
            if (publickey) {
              localStorage.setItem(loginAccount + '_publickey', publickey)
            }
            data = {
              phone_md5: CryptoJS.MD5(loginAccount).toString().substr(8, 16),
              password_hash: Cipher.RSAencrypt(config.pwdPublicKey, password),
              decrypt_type: 2,
              // 此cryptojs版本有bug，需要tostring转换一下
              key_md5: CryptoJS.MD5(publickey).toString().substr(8, 16)
            }
          } else if (+type === 0) {
            email = loginAccount || email
            if (privatekey) {
              localStorage.setItem(email + '_privatekey', privatekey)
            }
            if (publickey) {
              localStorage.setItem(email + '_publickey', publickey)
            }
            data = {
              email: email,
              password_hash: Cipher.RSAencrypt(config.pwdPublicKey, password),
              decrypt_type: 2,
              // 此cryptojs版本有bug，需要tostring转换一下
              key_md5: CryptoJS.MD5(publickey).toString().substr(8, 16)
            }
          } else if (+type === 2) {
            if (privatekey) {
              localStorage.setItem(loginAccount + '_privatekey', privatekey)
            }
            if (publickey) {
              localStorage.setItem(loginAccount + '_publickey', publickey)
            }
            data = {
              account_id: loginAccount,
              password_hash: Cipher.RSAencrypt(config.pwdPublicKey, password),
              decrypt_type: 2,
              key_md5: CryptoJS.MD5(publickey).toString().substr(8, 16)
            }
          }

          if (!localStorage.getItem('pcVersion')) {
            data['useragent'] = 'web'
          } else {
            data['useragent'] = localStorage.getItem('pcVersion')
          }

          // data add scan login flag.
          data['is_scan'] = ScanFlag.IS_SCAN_LOGIN
          // add device info.
          let deviceInfo = await getDeviceInfo()
          data['device_name'] = deviceInfo.deviceName
          data['device_id'] = deviceInfo.deviceId
          data['temporary_gray'] = isGrayEnv()

          this.login(data)
        }).catch((XMLHttpRequest, textStatus, errorThrown) => {
          if (this.ti < 3) {
            this.longPolling()
            this.ti++
          } else {
            this.flash = true
          }
        })
      },
      // 登录方法
      login (data) {
        axios.post('/proxy-api/client/user/index/web-login', qs.stringify(data))
        .then((result) => {
          console.log(result)
          if (result.data.status === '0') {
            localStorage.vanishAccount = result.data.payload.login_account
            setLoginInfo(result.data.payload)
            jumpToMainWeb(result.data.payload['is_gray'])
            // location.href = '../web/index.html'
          } else {
            this.flash = true
          }
        })
        .catch((error) => {
          console.log(error)
          this.flash = true
        })
      }
    },
    components: {
      Qrcode
    }
  }
</script>

<style lang="less">
  .qrlogin {
    .qrcode {
      position: relative;
      .flash {
        width: 100%;
        height: 100%;
        position: absolute;
        background: rgba(255,255,255,0.9);
        color: #000;
        text-align: center;
        line-height: 240px;
        font-size: 16px;
        cursor: pointer;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// Qrcode.vue?f48f6636